module.exports = ( Vue ) => { 

	Vue.prototype.csrf = $('meta[name="csrf-token"]').attr('content');
	
	Vue.prototype.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    var mobileCheck =  function() {
          var check = false;
          (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
          return check;
    };
    
	Vue.prototype.isMobile 	= mobileCheck();
	
    //Breadcrumb methods
	Vue.prototype.setBcLinks = function( arr ) {
	 	this.$store.state.bcLinks = arr;
 	}

	Vue.prototype.pushBcLink = function( obj, pos ) {
	 	if( typeof pos == 'undefined' ) {
	 
	 		this.$store.state.bcLinks.push( obj );
	 
	 	} else {

	 		this.$store.state.bcLinks.insert( obj, pos );

	 	}
	}

	Vue.prototype._blogGrid = function( c ) {
    
	    switch ( c ) {
	        case 'blog'         : return 'col-12'; 
	        case 'news'         : return 'col-12'; 
	        case 'influencer'   : return 'col-12 col-sm-6 col-md-4 col-xl-3 mb-4'; 
	        case 'event'        : return 'col-12 col-lg-6 mb-5'; 
	        case 'prompt'       : return 'col-12'; 
	        case 'learn'        : return 'col-12'; 
	        case 'interview'    : return 'col-12'; 
	            
	        default:
	            return 'col-12';
	            break;
	    }

	    return "col-12";
	}

	Vue.prototype._getBlogUrl = function( r, c ) {
	    let base = '',
	    	url = '';

	    switch ( c ) {
	        case 'blog'         : base = '/ai-blog/'; break;
	        case 'news'         : base = '/ai-news/'; break;
	        case 'influencer'   : base = '/ai-influencers/'; break;
	        case 'event'        : base = '/ai-events/'; break;
	        case 'prompt'       : base = '/ai-prompts/'; break;
	        case 'learn'        : base = '/ai-academy/'; break;
	        case 'interview'    : base = '/ai-interviews/'; break; 
	    }

	    if( typeof r == 'object' ) {
	    	 url = r.url;
	    } else {
	    	 url = r;
	    }

	    return base + url;
	}

	Vue.prototype._makeSocialLink = function( sm, v ) {
	 	
        if( !v ) {
            return "Not set.";
        }

        let base = '';

        if( sm == 'twitter' ) {
            base = 'https://twitter.com/';
        }
        
        if( sm == 'instagram' ) {
            base = 'https://www.instagram.com/';
        }

        if( sm == 'linkedin' ) {
            base = 'https://www.linkedin.com/in/';
        }

        return base + v;

	}

	Vue.prototype.popBcLink = function( url ) {
	 	
	 	for( var i in this.$store.state.bcLinks ) {
	 		
	 		if ( this.$store.state.bcLinks[i].url == url ) {
	 			this.$store.state.bcLinks.splice( i, 1 );
	 		}
	 		
	 	}

	}

	//Password validation regex
	Vue.prototype.passwordRegex 	= /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[.?,_\-!@#$%^&*()a-zA-Z\d]{6,}$/;

	//Common helper functions
	Vue.prototype._tools = {

		toolImage( t, thumb ) {
			if( t.image ) {

				if( thumb == true ) {
					return t.image.replace('tools','tools/thumbnail');
				}

				return t.image;
			}

			return '/resources/images/def-tool.jpg';
		},

		blogImage( t, thumb ) {
			if( t.image ) {

				if( thumb == true ) {
					return t.image.replace('blog','blog/thumbnail');
				}

				return t.image;
			}

			return '/resources/images/def-blog.jpg';
		},

		scImage( c, thumb ) {
			if( c.image ) {

				if( thumb == true ) {
					return c.image.replace('cats_sub','cats_sub/thumbnail');
				}

				return c.image;
			}

			return '/resources/images/def-cat.jpg';
		},

		mcImage( c, thumb ) {
			if( c.image ) {

				if( thumb == true ) {
					return c.image.replace('cats_main','cats_main/thumbnail');
				}

				return c.image;
			}

			return '/resources/images/def-cat.jpg';
		}
	}

	/*
	 *	this.navigate( ID, SPEED ) USAGE : 
	
		ID :
		1. not set, 0 or "top" - direct scroll to top of the page.
		2. "bottom" - Scroll to bottom.
		3. HTML element ID , like "#someID" - scroll to the element.

		SPEED :
		1. Not set, 0 or FALSE - no animation effect, instant scroll.
		2. Number in millisecond, like 200,500 etc for animation effect.
	
		Callback : function
	 */


	Vue.prototype.navigate = function( id, speed, cb ) {
		var pos = 0;

		if( !isNaN( id ) ) {
			
			pos = parseInt( id );

		} else if( id == 'bottom' ) {

			//Navigate to bottom
			pos = $('html,body').height();

		} else if( typeof id == 'string' && id != 'top' ) {

			pos = $(id).offset().top || 0;		
			pos -= ( this.isMobile ? 80 : 80 );

		}

		if( typeof speed == 'undefined' || !speed ) {
		
			$(window).scrollTop( pos );

			if( typeof cb == 'function' ) {
				cb();
			}
		
		} else {

			$("html, body").stop().animate({ scrollTop : pos }, speed , 'swing', function(){
				if( typeof cb == 'function' ) {
					cb();
				}
			});

		}
	}

	Vue.prototype.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

	//Date format functions
	Vue.prototype.cutString = function( str, size ) {
		if( typeof str != 'string' ){
			return '';
		} 

		if( str.length < size ) {
			return str;
		} else {
			return str.substr(0, size) + '...';
		}
	}

	Vue.prototype.dateOnly = function( date ){
		if( !date ){
			return '-';
		} else {
			var d = date.split(' ')[0];

			return d.split('-').reverse().join('.');
		}

	}

	Vue.prototype.toDate = function( d ) {
		if( !d ){
			return '-';
		}

		var date = d.split(' ');

		date[0] = date[0].split('-').reverse().join('.');

		return date.join(' ');

	}

	Vue.prototype.bgDate = function( date ){
		if( !date ){
			return '-';
		} else {
			var d = date.split(' ');

			return d[0].split('-').reverse().join('.') + ' ' + d[1].substr(0,5);
		}

	}

	Vue.prototype.timeOnly = function( date ){
		if( !date ){
			return '-';
		} else {
			var d = date.split(' ')[1];

			return d.substr(0,5);
		}

	}

	Vue.prototype.ucFirst = function( s ){
		if (typeof s !== 'string') return '';

		return s.charAt(0).toUpperCase() + s.slice(1);
	}


	Vue.prototype.daysFromDate = function( date ){
	    let time = new Date( date.split('-').join('/') ).getTime();
	    let now = new Date().getTime(); // or your date as well

	    let diff = now - time;

	    let result = Math.floor( diff / 86400000 );

	    if( result == 0 ) {
	    	return ' today';
	    }

	    if( result == 1 ) {
	        return " yesterday";
	    }
	 
	    return result + ' days ago';
	}

}